import { Box, Chip } from '@material-ui/core';
import CropFreeRoundedIcon from '@material-ui/icons/CropFreeRounded';

import { SButton, SInput, SText } from '@setvi/shared/components';

import { useStyles } from './styles';

interface QrSectionProps {
  numbers: string;
  setNumbers: (value: string) => void;
  /** Chips mirror the input, not the generated sheet. */
  machines: string[];
  loading: boolean;
  generate: () => void;
  removeMachine: (machine: string) => void;
  onChipClick: (index: number) => void;
}

export const QrSection = ({
  numbers,
  setNumbers,
  machines,
  loading,
  generate,
  removeMachine,
  onChipClick
}: QrSectionProps) => {
  const classes = useStyles();

  return (
    <Box>
      <SText title="QR codes" weight="semibold" />

      <Box mt={2}>
        <Box className={classes.qrRow}>
          <Box flex={1}>
            <SInput
              newDesign
              value={numbers}
              placeholder="e.g. 1, 2, 3"
              disabled={loading}
              onChange={e => setNumbers(e.target.value)}
            />
          </Box>
          <SButton
            variant="outlined"
            color="primary"
            startIcon={<CropFreeRoundedIcon />}
            loading={loading}
            disabled={loading || !numbers.trim()}
            onClick={generate}>
            Generate QR
          </SButton>
        </Box>
        <SText
          title="All scanned in machine numbers populate automatically."
          size="xs"
          maxLines="unset"
          fontColor="#5D7083"
        />
        <SText
          title="To remove a machine number, click the x next to the machine number."
          size="xs"
          maxLines="unset"
          fontColor="#5D7083"
        />
        {/* noLineClamp: the clamp's -webkit-box display drops the whitespace
            text nodes between the inline <b>/<i> elements. */}
        <SText size="xs" maxLines="unset" noLineClamp fontColor="#5D7083">
          Click Generate QR and <b>review and accept</b> the notes below{' '}
          <i>
            <u>before</u>
          </i>{' '}
          Add to Cart.
        </SText>

        {machines.length > 0 && (
          <Box className={classes.chipsRow}>
            {machines.map((machine, index) => (
              <Chip
                key={machine}
                className={classes.chip}
                label={`Machine ${machine}`}
                onClick={() => onChipClick(index)}
                onDelete={() => removeMachine(machine)}
              />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};
